function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1594",
  "data-name": "Group 1594",
  opacity: 0.498
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_981",
  "data-name": "Path 981",
  d: "M7.5,34.426a1.793,1.793,0,0,1,2.324,1.033,19.407,19.407,0,0,0,4.39,6.713A19.682,19.682,0,0,0,42.053,14.338a19.735,19.735,0,0,0-24.788-2.479l4.028,3.1L8.124,20.431l1.911-14.2,4.286,3.305a23.243,23.243,0,1,1,13.84,41.933,23.064,23.064,0,0,1-16.422-6.817A23.378,23.378,0,0,1,6.523,36.7,1.773,1.773,0,0,1,7.5,34.426Z",
  transform: "translate(-6.4 -4.98)",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  id: "_15",
  "data-name": 15,
  transform: "translate(22.5 28)",
  fill: "#fff",
  fontSize: 15,
  fontFamily: "Helvetica",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("tspan", {
  x: -8.342,
  y: 0
}, "15"));

var SvgBack15 = function SvgBack15(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    width: 45,
    height: 46.488,
    viewBox: "0 0 45 46.488",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack15, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-15.82a42568.svg";
export { ForwardRef as ReactComponent };